<a [href]="whatsappLink" target="_blank" class="whatsapp-button">
  <img src="assets/iconos/whatsapp-icon.png" alt="WhatsApp" />
</a>
